<template>
  <img :src="src ?? '/logo.png'" alt="Realgestión" class="object-contain" />
</template>

<script>
export default {
  props: {
    src: String,
  },
}
</script>
